import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { StateService, ScreenService, DevicesService, AppService, GeozoneService } from '@services';

/*Models */
import { Device, Geozone, Location } from '@models';

/*Config*/
import { CONFIG } from '@config';

declare var swal: any;

@Component({
  selector: 'app-geozone',
  templateUrl: './geozone.component.html',
  styleUrls: ['./geozone.component.scss']
})

export class GeozoneComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    public currentDevice: Device;
    newGeozoneName: string;
    geozoneList: Array<Geozone>;
    showAddGeozone = false;
    currentGeozone: Geozone;
    editableGeozone: Geozone;
    newGeozonePoints: Array<Location>;
    ifLoadingGeozones  = true;
    btnAddSubmit = {
      text:"Добавить зону",
      load:"Добавление..",
      default: "Добавить зону"
    }
    btnUpdateSubmit = {
      text:"Сохранить",
      load:"Сохранение..",
      default: "Сохранить"
    }

    btnDeleteSubmit = {
      text:"Удалить",
      load:"Удаление..",
      default: "Удалить"
    }
    ifSendAdd = false;
    ifSendDelete = false;
    ifSendUpdate = false;
    constructor(
        private stateService: StateService,
        private screenService: ScreenService,
        private devicesService: DevicesService,
        private geozoneService: GeozoneService,
        private router: Router){
            this.currentDevice = this.stateService.currentDevice;
            console.log(this.currentDevice)
            if (this.currentDevice) {
              if(this.currentDevice.provider.toLowerCase() != "magicsystems" && this.currentDevice.provider != "pandora"){
                this.router.navigate(['/personal']);
              }else{
                this.getGeozone();
              }
            }
            this.screenService.isStateHidden = true;
            this.stateService.currentDeviceObservable
            .takeUntil(this.ngUnsubscribe)
            .subscribe(device => {
              this.currentDevice = device;
              if (this.currentDevice) {
                if(this.currentDevice.provider.toLowerCase() != "magicsystems" && this.currentDevice.provider != "pandora"){
                  this.router.navigate(['/personal']);
                }else{
                  this.getGeozone();
                }
               
              }
            });
          this.screenService.onChangeGeozoneObservable
            .takeUntil(this.ngUnsubscribe)
            .subscribe(points => {
              if(this.currentGeozone && this.editableGeozone){
                this.editableGeozone.points = points;
              }else{
                this.newGeozonePoints = points;
              }
            });
    }

    ngOnInit(){
      

      this.screenService.isDataLoadingSubject.next(true);
          this.stateService.autoUpdatePositionSubject.next(false);
        this.screenService.isStateHidden = true;
        //this.screenService.isStateHidden = true;
    }

    getGeozone(){
        this.geozoneService.getGeozone(this.currentDevice.providerAccountId)
            .subscribe(response => {
                if(response && response.length){
                    this.geozoneList = response;
                }else{
                  this.geozoneList = [];
                }
                this.screenService.isDataLoadingSubject.next(false);
               
                console.log(response)
              }, error => {
                let errorMessage = 'Ошибка, попробуйте позже';
                if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
                  errorMessage = error.error.errorMessage;
                }
                swal({
                  type: 'error',
                  text: errorMessage,
                  showConfirmButton: true
                });
                this.geozoneList = [];
                this.screenService.isDataLoadingSubject.next(false);
                console.log(error);
              });
    }

    addGeozone(){
        
        if(!this.showAddGeozone){
            this.showAddGeozone = true;
            this.currentGeozone = null;
            this.editableGeozone = null;
            this.screenService.showNewGeozone();
        }else{
            this.addNewGeozone()
        }
    }
    cancelAddGeozone(){
        this.newGeozoneName = null;
        this.showAddGeozone = false;
        this.newGeozonePoints = null;
        this.screenService.clearGeozone();
    }
    deleteGeozone(geozone: Geozone){
      console.log(geozone)
      if(this.ifSendDelete || this.ifSendAdd || this.ifSendUpdate){
        return false;
      }
      swal({
        text: 'Удалить геозону?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#23518d',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена'
      }).then((result) => {
        if (result.value) {
          this.ifSendDelete = true;
          this.btnDeleteSubmit.text = this.btnDeleteSubmit.load;
          this.geozoneService.deleteGeozone(this.currentDevice.providerAccountId, geozone.id)
          .subscribe(response => {
            this.ifSendDelete = false;
            let indexDelete: number;
            this.geozoneList.map((item, index)=>{
                if(item.id === geozone.id && !indexDelete){
                  indexDelete = index;
                  return;
                }
              })

              this.geozoneList.splice(indexDelete,1);
              this.screenService.clearGeozone();
              swal({
                type: 'success',
                text: 'Геозона удалена',
                showConfirmButton: false,
                timer: 3000,
              });
              this.editableGeozone = null;
              console.log(response)
              this.btnDeleteSubmit.text = this.btnDeleteSubmit.default;
            }, error => {
              this.ifSendDelete = false;
              let errorMessage = 'Ошибка, попробуйте позже';
              if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
                errorMessage = error.error.errorMessage;
              }
              swal({
                type: 'error',
                text: errorMessage,
                showConfirmButton: true
              });
              this.btnDeleteSubmit.text = this.btnDeleteSubmit.default;
            console.log(error);
            });
          


        }
      });
      


    }
    addNewGeozone(){
      if(this.ifSendDelete || this.ifSendAdd || this.ifSendUpdate){
        return false;
      }
      if(this.newGeozonePoints && this.newGeozoneName){
        this.btnAddSubmit.text = this.btnAddSubmit.load;
        this.ifSendAdd = true;
        this.geozoneService.addGeozone(this.currentDevice.providerAccountId, this.newGeozoneName, this.newGeozonePoints)
          .subscribe(response => {
            this.ifSendAdd = false;
            swal({
              type: 'success',
              text: 'Геозона добавлена',
              showConfirmButton: false,
              timer: 3000,
            });
            this.geozoneList = null;
            this.getGeozone();
            this.cancelAddGeozone();
            this.newGeozoneName = null;
            this.btnAddSubmit.text = this.btnAddSubmit.default;
            console.log(response)
          }, error => {
            this.ifSendAdd = false;
            let errorMessage = 'Ошибка, попробуйте позже';
            if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
              errorMessage = error.error.errorMessage;
            }
            swal({
              type: 'error',
              text: errorMessage,
              showConfirmButton: true
            });
            this.btnAddSubmit.text = this.btnAddSubmit.default;
            console.log(error);
          });
      }
    }
    updateGeozone(geozone: Geozone){
      if(this.ifSendDelete || this.ifSendAdd || this.ifSendUpdate){
        return false;
      }
      if(this.editableGeozone && this.editableGeozone.points && this.editableGeozone.name){
        this.ifSendUpdate = true;
        this.btnUpdateSubmit.text = this.btnUpdateSubmit.load;
        this.geozoneService.updateGeozone(this.currentDevice.providerAccountId, this.editableGeozone.name, this.editableGeozone.id, this.editableGeozone.points, this.editableGeozone.isActive, this.editableGeozone.isSms)
        .subscribe(response => {

            swal({
              type: 'success',
              text: 'Геозона Обновлена',
              showConfirmButton: false,
              timer: 3000,
            });
            this.btnUpdateSubmit.text = this.btnUpdateSubmit.default;
            this.ifSendUpdate = false;
            this.geozoneList.map((geozone, index)=>{
              if(geozone.id === this.editableGeozone.id){
                this.geozoneList.splice(index, 1, response);
                return;
              }
            })
            this.closeGeozone()

          }, error => {
            this.ifSendUpdate = false;
            let errorMessage = 'Ошибка, попробуйте позже';
            if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
              errorMessage = error.error.errorMessage;
            }
            swal({
              type: 'error',
              text: errorMessage,
              showConfirmButton: true
            });
            console.log(error);
            this.btnUpdateSubmit.text = this.btnUpdateSubmit.default;
          });
      }

    }
    closeGeozone(){
      this.currentGeozone = null;
      this.editableGeozone = null;
      this.screenService.clearGeozone();
    }
    deleteEditableGeozone(){
      if(this.ifSendDelete || this.ifSendAdd || this.ifSendUpdate){
        return false;
      }
      if(this.currentGeozone && this.editableGeozone){
        this.editableGeozone.points = null;
      }else{
        this.newGeozonePoints = null;
      }
      this.screenService.clearEditableGeozone();
    }
    setCurrentGeozone(geozone: Geozone){
        this.showAddGeozone = false;
        this.newGeozoneName = null;
        this.newGeozonePoints = null;
        if(this.currentGeozone && this.currentGeozone.id == geozone.id){
          this.closeGeozone();
          return false;
        }
        this.editableGeozone = JSON.parse(JSON.stringify(geozone));
        this.currentGeozone = geozone;
        this.screenService.showGeozone(this.currentGeozone.points);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.stateService.toggleGraphStatsSubject.next(false);
        this.stateService.autoUpdatePositionSubject.next(true);
        this.screenService.clearGeozone();
    }
}




// WEBPACK FOOTER //
// ./src/app/view/geozone/geozone.component.ts